"use client";

import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";

const TotalRevenue = ({ data }) => {
  const [Chart, setChart] = useState();

  useEffect(() => {
    import("react-apexcharts").then((mod) => {
      setChart(() => mod.default);
    });
  }, []);

  // ✅ TEMP chart (replace with real trend later)
  const series = [
    {
      name: "Productivity",
      data: [70, 75, 80, 78, 85, 82, 88],
    },
  ];

  const options = {
    chart: {
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    colors: ["#FD5812"],
    dataLabels: { enabled: false },
    stroke: {
      width: 2,
      curve: "straight",
    },
    markers: {
      size: 3,
      strokeWidth: 0,
      hover: { size: 5 },
    },
    grid: { show: false },
    xaxis: {
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      labels: { show: false },
    },
    yaxis: { show: false },
  };

  // ✅ Productivity value (direct from backend)
  const productivity = data?.productivity_score ?? "--";

  // ✅ Comparison
  const change = data?.change_week || 0;
  const isUp = change >= 0;

  return (
    <Card className="border bg-white rounded-3 overflow-hidden mb-4">
      
      {/* Top */}
      <div className="d-flex align-items-center p-4 pb-3 mb-1">
        <div className="flex-shrink-0">
          <div
            className="wh-55 bg-danger bg-opacity-25 text-center rounded-2"
            style={{ lineHeight: "55px" }}
          >
            <i className="ri-line-chart-line fs-22 bg-danger text-white rounded-2 p-2"></i>
          </div>
        </div>

        <div className="flex-grow-1 ms-3">
          <h3 className="fs-24 fw-medium mb-0">
            {productivity !== "--" ? `${productivity}%` : "--"}
          </h3>
          <span>Productivity Score %</span>
        </div>
      </div>

      {/* Change */}
      <div className="d-flex align-items-center p-4 pb-0">
        <span
          className={`d-inline-block ${
            isUp
              ? "bg-success text-success border-success"
              : "bg-danger text-danger border-danger"
          } bg-opacity-10 border rounded-pill px-2 fw-medium d-flex align-items-center fs-12`}
        >
          <i className={`ri-arrow-${isUp ? "up" : "down"}-fill fs-14 lh-1`}></i>
          {Math.abs(change)}%
        </span>

        <span className="ms-2 fs-12">from last week</span>
      </div>

      {/* Chart */}
      <div style={{ margin: "-45px -11px -31px -15px" }}>
        {Chart && (
          <Chart
            options={options}
            series={series}
            type="line"
            height={120}
          />
        )}
      </div>
    </Card>
  );
};

export default TotalRevenue;